import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { hubApi } from "../api.js";

const PLANS = [
  { id: 1, name: "Light",      desc: "Ideal pentru restaurante mici", price: "€49/lună",  color: "#3b82f6", bg: "#eff6ff", border: "#bfdbfe" },
  { id: 2, name: "Pro",        desc: "Pentru restaurante în creștere",  price: "€99/lună",  color: "#7c3aed", bg: "#f5f3ff", border: "#ddd6fe" },
  { id: 3, name: "Enterprise", desc: "Soluție completă la scară mare",  price: "€199/lună", color: "#ea580c", bg: "#fff7ed", border: "#fed7aa" },
];

const toSlug = s => s.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

export default function AddRestaurantPage() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState(1);
  const [form, setForm] = useState({
    name: "", slug: "", contactPerson: "", contactEmail: "", contactPhone: "",
    backendUrl: "https://api.orderly.ro", frontendUrl: "", adminUrl: "", internalNotes: "",
  });

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleName = (v) => {
    const slug = toSlug(v);
    setForm(p => ({
      ...p, name: v, slug,
      frontendUrl: slug ? `https://${slug}.orderly.ro` : "",
      adminUrl:    slug ? `https://admin.${slug}.orderly.ro` : "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await hubApi.create({ ...form, plan });
      if (data.success) { toast.success("Restaurant adăugat!"); nav(`/restaurants/${data.restaurant._id}`); }
      else toast.error(data.message);
    } catch { toast.error("Eroare la adăugare."); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ padding: "40px 48px", maxWidth: 720 }}>
      {/* Back */}
      <button onClick={() => nav("/")}
        style={{ display: "flex", alignItems: "center", gap: 6, background: "none", border: "none", color: "#64748b", fontSize: 13, fontWeight: 600, cursor: "pointer", marginBottom: 28, padding: 0 }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
        Înapoi
      </button>

      <h1 style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", margin: "0 0 4px", letterSpacing: "-0.4px" }}>Adaugă restaurant</h1>
      <p style={{ color: "#94a3b8", fontSize: 14, margin: "0 0 32px" }}>Completează informațiile pentru noul restaurant</p>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 24 }}>

        {/* Plan selector */}
        <div>
          <SectionLabel>Plan abonament</SectionLabel>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
            {PLANS.map(p => (
              <div key={p.id} onClick={() => setPlan(p.id)}
                style={{ padding: "18px 16px", borderRadius: 12, cursor: "pointer", border: `2px solid ${plan === p.id ? p.color : "#e2e8f0"}`, background: plan === p.id ? p.bg : "#fff", transition: "all 0.15s" }}>
                {plan === p.id && (
                  <div style={{ width: 18, height: 18, borderRadius: "50%", background: p.color, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                )}
                {plan !== p.id && <div style={{ width: 18, height: 18, borderRadius: "50%", border: "2px solid #e2e8f0", marginBottom: 10 }} />}
                <div style={{ fontWeight: 800, fontSize: 14, color: plan === p.id ? p.color : "#0f172a", marginBottom: 3 }}>{p.name}</div>
                <div style={{ fontSize: 11, color: "#94a3b8", lineHeight: 1.4, marginBottom: 8 }}>{p.desc}</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: plan === p.id ? p.color : "#374151" }}>{p.price}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Name & Slug */}
        <Card>
          <SectionLabel>Informații de bază</SectionLabel>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <Field label="Nume restaurant *" value={form.name} onChange={handleName} placeholder="ex: La Mama" required />
            <Field label="Slug *" value={form.slug} onChange={v => set("slug", v)} placeholder="ex: la-mama" required />
          </div>
        </Card>

        {/* URLs */}
        <Card>
          <SectionLabel>URL-uri</SectionLabel>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {[["URL Frontend", "frontendUrl", "https://demo.orderly.ro"], ["URL Admin", "adminUrl", "https://admin.demo.orderly.ro"], ["URL Backend API", "backendUrl", "https://api.orderly.ro"]].map(([lbl, key, ph]) => (
              <div key={key} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ width: 110, fontSize: 12, color: "#94a3b8", fontWeight: 600, flexShrink: 0 }}>{lbl}</span>
                <input value={form[key]} onChange={e => set(key, e.target.value)} placeholder={ph}
                  style={{ flex: 1, padding: "9px 12px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f8fafc", fontSize: 13, outline: "none", color: "#0f172a" }}
                  onFocus={e => e.target.style.borderColor = "#6366f1"}
                  onBlur={e => e.target.style.borderColor = "#e2e8f0"} />
              </div>
            ))}
          </div>
        </Card>

        {/* Contact */}
        <Card>
          <SectionLabel>Informații contact</SectionLabel>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
            <Field label="Persoană contact" value={form.contactPerson} onChange={v => set("contactPerson", v)} placeholder="Andrei Pop" />
            <Field label="Email" type="email" value={form.contactEmail} onChange={v => set("contactEmail", v)} placeholder="andrei@demo.ro" />
            <Field label="Telefon" value={form.contactPhone} onChange={v => set("contactPhone", v)} placeholder="+40 7xx xxx xxx" />
          </div>
        </Card>

        {/* Notes */}
        <Card>
          <SectionLabel>Note interne</SectionLabel>
          <textarea value={form.internalNotes} onChange={e => set("internalNotes", e.target.value)}
            placeholder="Orice detalii relevante despre acest restaurant..." rows={3}
            style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f8fafc", fontSize: 14, outline: "none", color: "#0f172a", resize: "vertical", fontFamily: "inherit", lineHeight: 1.6, boxSizing: "border-box" }}
            onFocus={e => e.target.style.borderColor = "#6366f1"}
            onBlur={e => e.target.style.borderColor = "#e2e8f0"} />
        </Card>

        {/* Submit */}
        <button type="submit" disabled={loading}
          style={{ padding: "13px", borderRadius: 10, border: "none", background: loading ? "#a5b4fc" : "#6366f1", color: "#fff", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          {loading ? <><Spinner /> Se salvează...</> : "Adaugă restaurant →"}
        </button>
      </form>
    </div>
  );
}

function Card({ children }) {
  return <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "20px 22px" }}>{children}</div>;
}

function SectionLabel({ children }) {
  return <p style={{ fontSize: 12, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.8px", margin: "0 0 14px" }}>{children}</p>;
}

function Field({ label, type = "text", value, onChange, placeholder, required }) {
  return (
    <div>
      <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required={required}
        style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f8fafc", fontSize: 14, outline: "none", color: "#0f172a", boxSizing: "border-box" }}
        onFocus={e => e.target.style.borderColor = "#6366f1"}
        onBlur={e => e.target.style.borderColor = "#e2e8f0"} />
    </div>
  );
}

function Spinner() {
  return <svg style={{ animation: "spin 0.8s linear infinite" }} width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>;
}
